<template>
  <div id="grid-candidatos">
    <v-layout>
      <v-flex xs3 order-md4>
        <v-btn
          v-if="
            botonCargar == true &&
            tab == 'Reclutados' &&
            (usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR')
          "
          depressed
          :loading="loading1"
          outline
          icon
          fab
          dark
          color="primary"
          medium
          title="Cargar planilla"
          @click="validarArchivo()"
        >
          Validar
        </v-btn>
      </v-flex>
      <v-flex xs3 order-md4>
        <v-btn
          v-if="botonProcesar == true"
          color="primary"
          dark
          :loading="loading1"
          class="mb-2"
          @click="procesarCarga()"
        >
          Cargar
        </v-btn>
      </v-flex>
      <v-flex xs5 order-md3 grid-list-xl>
        <v-toolbar-title
          v-if="
            tab == 'Reclutados' &&
            (usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR')
          "
          class="indigo--text"
          >Carga masiva Reclutados</v-toolbar-title
        >
        <data-adjunto
          v-if="
            tab == 'Reclutados' &&
            (usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR')
          "
          :documentoId="id"
          :tipeView="tipeView"
          :tipeArchive="tipeArchive"
        ></data-adjunto>
      </v-flex>
      <v-flex xs3 order-md2 order-xs1>
        <v-btn
          v-if="
            tab == 'Reclutados' &&
            (usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR')
          "
          color="primary"
          @click="newCandidato()"
        >
          Nuevo Reclutado</v-btn
        >
      </v-flex>
      <v-flex xs4 order-md1>
        <v-btn
          v-if="
            tab == 'Reclutados' &&
            (usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR')
          "
          color="primary"
          @click="descargaCandidato()"
          >Descarga Plantilla Reclutados</v-btn
        >
      </v-flex>
    </v-layout>
    <v-toolbar card color="white">
      <v-toolbar-title class="indigo--text"
        >Búsqueda de Reclutados</v-toolbar-title
      >
    </v-toolbar>
    <v-layout class="d-flex pa-2">
      <div class="d-flex pa-2" xs12 sm6>
        <v-text-field
          width="300px"
          v-model="txtBusqueda"
          placeholder="Ingresa el nombre o código para la busqueda por palabra clave"
          single-line
        ></v-text-field>
        <v-btn
          color="primary"
          @click="loadData()"
          :disabled="txtBusqueda.length < 3"
          class="shrink"
          ><v-icon dark left>search</v-icon>Buscar</v-btn
        >
        <v-btn
          color="secondary"
          @click="limpiaBuscador()"
          :disabled="txtBusqueda.length < 3"
          class="shrink"
          ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
        >
      </div>
    </v-layout>

    <v-layout justify-center>
      <v-flex lg12>
        <div v-if="loading">
          <loading></loading>
        </div>
        <div v-if="alerta">
          <alert-empty></alert-empty>
        </div>
        <v-data-table
          :headers="headers"
          :items="itemsDocumento"
          :pagination.sync="miPaginacion"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td nowrap>{{ props.item.rut + "-" + props.item.dv }}</td>
            <td class="text-xs-left">{{ props.item.nombre }}</td>
            <td class="text-xs-left">
              {{ props.item.region != null ? props.item.region.nombre : "-" }}
            </td>
            <td>
              {{ props.item.comuna != null ? props.item.comuna.nombre : "-" }}
            </td>
            <td class="text-xs-left">
              {{
                props.item.rolCapId != null
                  ? props.item.rolCapId.descripcion
                  : "-"
              }}
            </td>
            <td class="text-xs-left">
              {{ matricula(props.item.tipoMatricula) }}
            </td>
            <td>
              <v-btn
                depressed
                outline
                icon
                fab
                dark
                color="green darken-4"
                small
                title="Ver reclutado"
                @click="viewCandidato(props.item.id)"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                v-if="
                  (tab == 'Reclutados' && usuarioLoggedTipe == 'PROVEEDOR') ||
                  usuarioLoggedTipe == 'ADMINISTRADOR'
                "
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
                title="Editar reclutado"
                @click="editCandidato(props.item.id)"
              >
                <v-icon>open_in_new</v-icon>
              </v-btn>
              <v-btn
                v-if="
                  tab == 'Reclutados' &&
                  (usuarioLoggedTipe == 'PROVEEDOR' ||
                    usuarioLoggedTipe == 'ADMINISTRADOR')
                "
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
                title="Descargar documento"
                @click="openDeleteDialog(props.item.id)"
              >
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
        <v-card-actions
          v-if="
            tab == 'Reclutados' &&
            (usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR')
          "
          class="pb-3"
        >
          <v-spacer></v-spacer>
          <v-btn
            class="btn-sigas"
            depressed
            outline
            icon
            fab
            dark
            color="green darken-4"
            small
          >
            <v-icon>remove_red_eye</v-icon>
          </v-btn>
          &nbsp;Ver reclutados
          <v-btn
            class="btn-sigas"
            depressed
            outline
            icon
            fab
            dark
            color="primary"
            small
          >
            <v-icon>open_in_new</v-icon>
          </v-btn>
          &nbsp;Editar reclutados
          <v-btn
            class="btn-sigas"
            depressed
            outline
            icon
            fab
            dark
            color="primary"
            small
          >
            <v-icon>cloud_download</v-icon>
          </v-btn>
          &nbsp;Descargar
        </v-card-actions>
        <!-- PAGINACION -->
        <v-flex xs12 sm6>
          <v-text-field
            value=""
            label="Total de Registros"
            v-model="itemsDocumento.length"
            disabled
          ></v-text-field>
        </v-flex>
        <div class="pt-2">
          <v-pagination
            v-model="miPaginacion.page"
            :length="numPaginas"
            :total-visible="7"
            circle
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn
        v-if="botonDescarga == true"
        color="primary"
        @click="descargaMasivaReclutados()"
        >Descarga</v-btn
      >
      <v-spacer></v-spacer>
    </v-card-actions>
    <!-- dialogo -->
    <v-dialog v-model="dialog" persistent max-width="890">
      <v-card>
        <v-card-title class="headline">Descargar Documentos</v-card-title>
        <v-card-text>
          <v-flex lg12>
            <v-spacer></v-spacer>
            <v-data-table
              :headers="headers2"
              :items="itemsDocs"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">
                  {{ props.item.candidato.rut + props.item.candidato.dv }}
                </td>
                <td class="text-xs-left">{{ props.item.asunto }}</td>
                <td class="text-xs-left">{{ props.item.fecha_creacion }}</td>
                <td class="text-xs-left">{{ props.item.filename }}</td>
                <div class="text-xs-center">
                  <td>
                    <v-btn
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                      title="Descargar documento"
                      @click="downloadFile(props.item.filename)"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </td>
                </div>
              </template>
            </v-data-table>
            <!-- LEYENDA TABLA PROVEEDORES -->
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
            </v-card-actions>
            <!--fin iconos leyenda-->
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="dialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRut" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Resumen de Archivo </v-card-title>
        <v-card-text>
          <v-flex lg12>
            <v-spacer></v-spacer>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
            </v-card-actions>
            <p v-if="respOk == false">{{ this.resp }}</p>
            <div class="text-resp" v-if="respOk == true">
              <v-icon class="ico-resp">check_circle</v-icon>
              <p>Archivo sin errores!</p>
            </div>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeModal()"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogLoading" persistent max-width="390">
      <loading-descarga></loading-descarga>
    </v-dialog>
    <!-- dialogo -->
  </div>
</template>
<script>
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "grid-candidatos",
  components: {
    LoadingDescarga,
    DataAdjunto,
    Loading,
    AlertEmpty,
  },
  mixins: [misMixins],
  props: {
    tipeView: String,
  },

  data() {
    return {
      txtBusqueda: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      resp: "",
      dialogLoading: false,
      loading: false,
      loading1: false,
      alerta: false,
      dialog: false,
      dialogRut: false,
      botonProcesar: false,
      botonDescarga: false,
      respOk: false,
      botonCargar: true,
      id: "",
      rowsPerPageItems: [20],
      idContrato: "",
      headers: [
        {
          text: "Rut Reclutados",
          align: "left",
          sortable: false,
          value: "rut",
        },
        { text: "Reclutado/a", sortable: false, value: "nombre" },
        { text: "Region", sortable: false, value: "region" },
        { text: "Comuna", sortable: false, value: "comuna" },
        { text: "Rol", sortable: false, value: "rol" },
        { text: "Tipo", sortable: false, value: "forma_cap" },
        {
          text: "Accion para reclutados activados",
          sortable: false,
          value: "",
        },
      ],
      headers2: [
        { text: "Rut Candidato", align: "left", sortable: false, value: "rut" },
        { text: "Asunto", sortable: false, value: "asunto" },
        { text: "Fecha de creacion", sortable: false, value: "fecha_creacion" },
        { text: "Filename", sortable: false, value: "filename" },
        {
          text: "Descargar documentos",
          sortable: false,
          value: "",
        },
      ],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsDocs: [],
      itemsDocumento: [],
      idUserLogged: "",
      proceso: "",
      tipeArchive: "",
      rutValid: [],
      rutNoValid: [],
      btnHidden: false,
      tab: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.tipeArchive = ".pdf,.doc,.jpg,.png,.xlsx";

    this.loadData();
  },

  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    matricula(tipoMatricula) {
      if (tipoMatricula == 1) {
        return "PRESENCIAL";
      } else if (tipoMatricula == 2) {
        return "ABREVIADA";
      } else if (tipoMatricula == 3) {
        return "B-LEARNING";
      }
      return "";
    },
    openDeleteDialog(id) {
      this.loadDataDocumentos(id);
      this.dialog = true;
    },
    async loadDocumentos(id) {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/candidatos/docsCandidato/" + idContrato + "/" + id)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataDocumentos(id) {
      this.loading = true;
      this.itemsDocs = await this.loadDocumentos(id);
      this.loading = false;
    },
    limpiaBuscador() {
      this.txtBusqueda = "";
      this.loadData();
    },
    async loadCandidatosFilter() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      return await axios
        .post("/candidatos/filterTxt", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadCandidatosFilter();
      this.miPaginacion.totalItems = this.itemsDocumento.length;

      if (this.itemsDocumento.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    descargaMasivaReclutados() {
      this.dialogLoading = true;
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
        origenBusqueda: this.tab,
      };
      axios
        .post("/candidatos/downloadExcel", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_MASIVA_RECLUTADOS.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    descargaCandidato() {
      this.dialogLoading = true;
      axios
        .get("/candidatos/download/" + this.idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "PLANILLA_RECLUTADOS.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
        // this.$router.go(-1)
      }, 1000);
    },
    async validarArchivo() {
      this.loading1 = true;
      this.resp = await this.preProcessFile();
      let respuesta = this.resp;
      console.log(respuesta);
      //this.rutValid = this.resp.validRut;
      if (respuesta == undefined) {
        console.log(respuesta);
      } else {
        let resp = this.respIsEmpty(this.resp);
        if (resp) {
          this.respOk = true;
        } else {
          this.rutNoValid = respuesta;
        }
        this.dialogRut = true;
      }
      this.loading1 = false;
    },
    async preProcessFile() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documentoCV: base64EncodedStr,
        idContrato: idContrato,
      };
      return await axios
        .post("/candidatos/preProcessFileCandidatosAplicacion", this.body)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
    closeModal() {
      this.dialogRut = false;
      let resp = this.respIsEmpty(this.resp);
      if (resp) {
        this.botonProcesar = true;
        this.botonCargar = false;
      } else {
        this.botonProcesar = false;
        this.botonCargar = true;
      }
    },
    respIsEmpty(mapArchivo) {
      for (var key in mapArchivo) {
        if (mapArchivo.hasOwnProperty(key)) return false;
      }
      return true;
    },
    async procesarCarga() {
      this.loading1 = true;
      this.resp = await this.envio();
      this.reload();
    },
    async envio() {
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        documentoCV: base64EncodedStr,
        idContrato: idContrato,
      };
      return await axios
        .post("/candidatos/file", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
    newCandidato() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CandidatosRegistra",
          params: { tipeView: "crear" },
        });
      }, 1000);
    },
    editCandidato(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CandidatosRegistra",
          params: { id: id, tipeView: "modifica" },
        });
      }, 1000);
    },
    async downloadFile(filename) {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        fileName: filename,
        idContrato: idContrato,
      };
      return await axios
        .post("candidatos/downloadCV", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", this.fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    viewCandidato(id) {
      this.loadDataDocumentos(id);
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "CandidatosRegistra",
          params: { id: id, tipeView: "consulta" },
        });
      }, 1000);
    },
  },
};
</script>
